import {useLayoutEffect, useRef, useState} from 'react'

export function useLayoutEffectMemo<TValue>(factory: () => TValue, dependencies: any[]) {
  const [memoState, setMemoState] = useState<TValue | null>(null)

  useLayoutEffect(() => {
    setMemoState(factory())
  }, dependencies)

  return memoState
}
